import { UserRoles } from '@onereach/auth-ui-module';

import config from '@/config';
import { Client } from '@/constants';

function checkInternalMode(role: string | null): boolean {
  return (
    [
      UserRoles.superAdmin,
      UserRoles.admin,
    ].some(rl => rl === role) &&
    config.CLIENT === Client.OPS
  );
}

export default checkInternalMode;
